const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class FulfilmentSelectorManualAddressController {
    constructor($q, settings, addressService, analyticsService, fulfilmentService, fulfilmentSelectorService) {
        this.$q = $q;
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentService = fulfilmentService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
    }

    $onInit() {
        this.fulfilmentSelectorService.setModalTitleMessage(this.settings.fulfilmentSelector.manualAddressTitle);

        this.address = {
            postcode: null, street1: null, street2: null, suburbId: null, suburb: null,
        };

        this.screenName = 'Manual address entry';
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .build();

        this.analyticsService.push(event);

        this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
    }

    setSuburb(suburb) {
        if (!suburb) return null;

        if (suburb.Id && suburb.Text && suburb.Id !== 'n/a') {
            this.address.suburbId = suburb.Id;
            this.address.suburb = suburb.Text;
        }
        return suburb;
    }

    loadSuburbs() {
        if (this.address.postcode && this.address.postcode.length === 4) {
            return this.addressService.getSuburbs(this.address.postcode).then((suburbs) => {
                this.suburbs = suburbs;
                if (this.suburbs && this.suburbs.length) {
                    this.setSuburb(this.suburbs[0]);
                }
            });
        } else if (this.address.postcode && this.address.postcode.length !== 4) {
            this.suburbs = null;
            this.address.suburb = null;
        }
        return this.$q.reject();
    }

    validateInput(address) {
        if (!address.street1 || address.street1.length > this.settings.oneSite.maxCharactersManualAddress1) return false;
        if (!address.postcode) return false;
        if (!address.suburbId) return false;
        return true;
    }

    saveManualAddress() {
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Button/link click')
            .withValue('Save')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .build();

        this.analyticsService.push(event);

        if (this.validateInput(this.address)) {
            this.addressService.saveManualAddress(this.address)
                .then(addressResponse => this.saveFulfilment(addressResponse.Address));
        }
    }

    saveFulfilment(address) {
        this.fulfilmentService.saveFulfilment({
            fulfilmentMethod: 'Courier',
            address,
            fulfilmentWindow: { time: null },
            billingAddressId: null,
        });

        this.fulfilmentService.savedAddress = address;
        this.fulfilmentService.selectedFulfilmentMethod = this.fulfilmentService.fulfilmentOptions.delivery;

        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.startShopping;
    }


    $onDestroy() {
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }
}

FulfilmentSelectorManualAddressController.$inject = ['$q', 'Settings', 'AddressService', 'AnalyticsService', 'FulfilmentService', 'FulfilmentSelectorService'];

const fulfilmentSelectorManualAddressComponentDefinition = {
    controller: FulfilmentSelectorManualAddressController,
    template: require('./fulfilment-selector-manual-address.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorManualAddressController,
    fulfilmentSelectorManualAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-manual-address.component.js